<script setup lang="ts">
import Content from '~/components/pages/content.vue';
import Vertical from '~/components/pages/vertical.vue';

const route = useRoute();

const page = useGetPage();

const isVertical = computed(() => {
  return !!page.value && page.value?.MobileApp?.component === 'CasinoComponent';
});
const isContent = computed(() => {
  return (
    (!!page.value && page.value?.MobileApp?.component === 'WebViewComponent') ||
    page.value?.MobileApp?.component === 'ContactUsComponent' ||
    page.value?.MobileApp?.component === 'PromotionComponent' ||
    page.value?.MobileApp?.component === 'PromopagesComponent' ||
    page.value?.MobileApp?.component === ''
  );
});
</script>

<template>
  <div>
    <Vertical v-if="isVertical" :key="String(route.params.contentType)" />
    <Content
      v-else-if="isContent"
      :key="`${String(route.params.contentType)}-${page?.MobileApp?.component}`"
    />
  </div>
</template>

<style scoped lang="scss"></style>
